export default amount => {
  if (amount[amount.length - 2] === '.')
    return amount + '0'
  else return amount
}